import React, { useContext } from "react";
import "./TopBar.scss";
import {
  openNegishut,
  shareFacebook,
  shareWhatsapp,
} from "../../services/sharing";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { AppContext } from "../../stores/application.store";
import ProgressBar from "../Animations/ProgressBar/ProgressBar";
const TopBar = () => {
  const menu = useRef();

  const {
    shareOpen,
    setShareOpen,
    pageView,
    votingTextPrimary,
    votingTextSecondary,
  } = useContext(AppContext);

  return (
    <div
      className={`topbar ${
        pageView == 1 || pageView == 2 || pageView == 3 ? "voting" : ""
      } ${pageView == 4 ? "thank-you" : "thank-you"}`}
    >
      <div className="main">
        <div className="logos">
          <div
            className="logo glgltz"
            onClick={() =>
              window.open(
                "https://glz.co.il/%D7%92%D7%9C%D7%92%D7%9C%D7%A6",
                "_blank"
              )
            }
          ></div>
          <div
            className="logo ynet"
            onClick={() => window.open("https://ynet.co.il/", "_blank")}
          ></div>
          <div
            className="logo bug"
            onClick={() =>
              window.open(
                "https://www.bug.co.il/?utm_source=glglz_quiz&utm_medium=ynet&utm_campaign=bug",
                "_blank"
              )
            }
          ></div>
          <div
            className="logo sonos"
            onClick={() =>
              window.open(
                "https://www.bug.co.il/sonos?utm_source=glglz_quiz&utm_medium=ynet&utm_campaign=bug",
                "_blank"
              )
            }
          ></div>
          {pageView !== 0 && (
            <div className="glgltz-text desktop-only">
              <h3>המצעד הישראלי השנתי</h3>
            </div>
          )}
        </div>

        <div className="icons">
          <div className="whatsapp" onClick={shareWhatsapp}></div>
          <div className="facebook" onClick={shareFacebook}></div>
          <div className="negishut" onClick={openNegishut}>
            <div className="icon"></div>
          </div>
        </div>
        <div
          className={`share-container ${shareOpen ? "open" : ""}`}
          ref={menu}
        >
          <div
            className="share-button"
            onClick={() => setShareOpen(!shareOpen)}
          >
            <div className="icon"></div>
          </div>
          <div className="menu-background"></div>
          <div
            className="facebook-button"
            onClick={() => shareFacebook()}
          ></div>
          <div
            className="whatsapp-button"
            onClick={() => shareWhatsapp()}
          ></div>
        </div>
      </div>
      {pageView !== 0 && (
        <div className="glgltz-text mobile-only">
          <h3>המצעד הישראלי השנתי</h3>
        </div>
      )}
      <div className="progress-section">
        <div className="progress-bars-container">
          <ProgressBar barType={1} title="שירי השנה" />
          <ProgressBar barType={2} title="אנשי השנה" />
          <ProgressBar barType={3} title="פריצת השנה" />
        </div>
      </div>
      <div className="voting-text-container">
        <h4 className="voting-text-primary">{votingTextPrimary}</h4>
        <h4 className="voting-text-secondary">{votingTextSecondary}</h4>
      </div>
    </div>
  );
};

export default TopBar;
